import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import { APP_BASE_URL } from "../../config/api";

// export const fetchEntityId = createAsyncThunk(
//     'account/fetchEntityId',
//     async (accountId, { rejectWithValue }) => {
//       try {
//         console.log("fetchEntityId thunk: " + accountId);
//         const response = await fetch(`${APP_BASE_URL}/admin/entity/${accountId}`);
//         console.log("Entity response: " + response);
//         if (!response.ok) {
//           const errorData = await response.json();
//           throw new Error(errorData.detail || 'Failed to fetch entity');
//         }
//         const entity = await response.json();
//         return { accountId, entityId: entity.id };
//       } catch (error) {
//         console.error('Error fetching entity ID in thunk:', error);
//         return rejectWithValue(error.message || 'Failed to fetch entity ID');
//       }
//     }
//   );

const getAccountIdFromLocalStorage = () => localStorage.getItem('accountId') || '';
const getEntityIdFromLocalStorage = () => localStorage.getItem('entityId') || null;

const initialState = {
    accountId: getAccountIdFromLocalStorage(),
    entityId: getEntityIdFromLocalStorage(),
    loading: false,
    error: null,
};

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers:{
        setAccountId: (state,action) =>{
            state.accountId = action.payload;
            localStorage.setItem('accountId', action.payload); 
        },
        setEntityId: (state, action) => {
            state.entityId = action.payload;
            if (action.payload) {
              localStorage.setItem('entityId', action.payload);
            } else {
              localStorage.removeItem('entityId');
            }
        },
        clearAccountData: (state) => {
            state.accountId = '';
            state.entityId = null;
            state.loading = false;
            state.error = null;
            localStorage.removeItem('accountId');
            localStorage.removeItem('entityId');
        },
        clearAccountError: (state) => {
            state.error = null;
        }
    },
    // extraReducers: (builder) => {
    //     builder
    //       .addCase(fetchEntityId.pending, (state) => {
    //         state.loading = true;
    //         state.error = null;
    //     })
    //       .addCase(fetchEntityId.fulfilled, (state, action) => {
    //         state.loading = false;
    //         state.accountId = action.payload.accountId; // Ensure accountId is set from thunk payload
    //         state.entityId = action.payload.entityId;
    //         localStorage.setItem('accountId', action.payload.accountId); // Persist
    //         localStorage.setItem('entityId', action.payload.entityId);   // Persist
    //     })
    //       .addCase(fetchEntityId.rejected, (state, action) => {
    //         state.loading = false;
    //         state.error = action.payload || 'Failed to fetch entity ID';
    //         state.entityId = null; // Clear entityId on error
    //         localStorage.removeItem('entityId'); // Clear from localStorage
    //     });
    // },
});

export const { setAccountId, setEntityId, clearAccountData, clearAccountError } = accountSlice.actions;
export default accountSlice.reducer;
